export const LOADING_TURNOS = "LOADING_TURNOS";
export const GET_TURNOS_SUCCESS = "GET_TURNOS_SUCCESS";
export const GET_TURNOS_FAILURE = "GET_TURNOS_FAILURE";
export const SET_TURNOS_PAGE = "SET_TURNOS_PAGE";
export const RESET_TURNOS = "RESET_TURNOS";
